module.exports = __webpack_public_path__ + "assets/2-contact-rainmakers-recruiters-for-account-executives.aaf90759.png";